import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  IconButton,
  Typography,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";
import { fAlertToast } from "../../../Utility/Utilitys";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const GCSerialSelectionModal = ({
  SerialDetalModal={},
  open,
  handleClose,
  availableSerials = [],
  selectedSerials = [],
  selectedAvailableIds = [],
  setAvailableSerials,
  setSelectedAvailableIds,
  selectedRightIds = [],
  setSelectedRightIds,
  handleMoveToRight = () => {},
  handleMoveToLeft = () => {},
  DocumentRow = [],
  DocumentColumns = [
    { field: "itemCode", headerName: "Item.Code", width: 150 },
  ],
  title = "Serial Selection",
  handleSave, // Pass handleSave from the parent component to manage saved selections
  srNoColumn = [],
  avlColumn = [],
  serialInput,
  handleSerialInputChange,
  handleKeyPress,
  handleClearSelection,
  xDisable,
}) => {
  
  const [isEditing, setIsEditing] = useState(false);

  // const [availableSerials, setAvailableSerials] = useState([
  //     { id: 1, mfd: '06/09/2024', exp: '06/09/2024', batchNo: '101', qty: 1, reserver: 0, allocQty: 0 },
  //     { id: 2, mfd: '01/01/1900', exp: '01/01/1900', batchNo: '102', qty: 1, reserver: 0, allocQty: 0 },
  //     { id: 3, mfd: '23/08/2024', exp: '23/08/2024', batchNo: '101', qty: 1, reserver: 0, allocQty: 0 },
  //   ]);

  //   const [selectedSerials, setSelectedSerials] = useState([]);
  //   const [selectedAvailableIds, setSelectedAvailableIds] = useState([]);
  //   const [selectedRightIds, setSelectedRightIds] = useState([]);

  const isRowDisabled = (id) => {
    return selectedSerials.some((serial) => serial.C_BatchNo == id);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {/* First Grid for Document Details */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              rows={DocumentRow}
              columns={DocumentColumns}
              //   pageSize={1}
              disableSelectionOnClick
              //   autoHeight
              hideFooter={DocumentRow.length < 100}
              sx={{ height: 110 }} // Fixed height of 300px
            />
          </Grid>
        </Grid>
        <DialogActions>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 20, alignItems: "baseline" }}
          >
            {/* Available Serial Table */}
            <Grid item xs={12} md={3}>
              {SerialDetalModal?.Batch == "N" && (
                <h6>Enable Scan Serial No & Select</h6>
              )}
            </Grid>
            <Grid item xs={12} md={4} className="d-flex">
              {SerialDetalModal?.Batch == "N" && (
                <TextField
                  fullWidth
                  size="small"
                  value={serialInput}
                  onChange={handleSerialInputChange}
                  onKeyUp={handleKeyPress} // Handle enter key
                  disabled={xDisable}
                />
              )}
              {SerialDetalModal.Batch == "N" && (
                <Button variant="contained" onClick={handleKeyPress}  disabled={xDisable}>
                  <ArrowForwardIcon />
                </Button>
              )}
            </Grid>

            <Grid item xs={12} md={5} textAlign={"end"}>
              <Typography>
                Total Qty{" "}
                {DocumentRow.reduce((sum, item) => sum + item.B_Qty, 0)}
              </Typography>
            </Grid>
          </Grid>
        </DialogActions>

        {/* Second Grid for Serial Selection */}
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          {/* Available Serial Table */}
          <Grid item xs={12} md={6.5}>
            <h4>Available Serial</h4>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              rows={availableSerials
                .map((serial) => ({
                ...serial,
                disableCheckbox: isRowDisabled(serial.C_PTyp1),
              }))
            }
              columns={avlColumn} 
              checkboxSelection={!xDisable}
              disableSelectionOnClick
              sx={{ height: 300 }} // Fixed height of 300px
              onCellEditStart={() => setIsEditing(true)}
              onCellEditStop={() => setIsEditing(false)}
              onCellEditCommit={() => setIsEditing(false)}
              isRowSelectable={(params) => !isRowDisabled(params.row.C_PTyp1)} 
              selectionModel={selectedAvailableIds}
              onSelectionModelChange={(ids) => setSelectedAvailableIds(ids)}
              hideFooter={availableSerials.length < 100}
            />
          </Grid>

          {/* Middle Buttons for Selection */}
          <Grid
            item
            xs={12}
            md={1}
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Button
              onClick={handleMoveToRight}
              disabled={
                selectedAvailableIds.length === 0 || isEditing || xDisable
              }
            >
              &gt;&gt;
            </Button>
            <Button
              onClick={handleMoveToLeft}
              disabled={selectedRightIds.length === 0 || isEditing | xDisable}
            >
              &lt;&lt;
            </Button>
            <Button
              onClick={handleClearSelection}
              variant="outlined"
              style={{ marginTop: "10px" }}
              disabled={xDisable}
            >
              Clear
            </Button>
          </Grid>

          {/* Selected Serial Table */}
          <Grid item xs={12} md={4.5}>
            <h4>Selected Serial</h4>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              rows={selectedSerials}
              columns={srNoColumn}
              pageSize={5}
              checkboxSelection={!xDisable}
              disableSelectionOnClick
              sx={{ height: 300 }} // Fixed height of 300px
              selectionModel={selectedRightIds}
              onSelectionModelChange={(ids) => setSelectedRightIds(ids)}
              hideFooter={selectedSerials.length < 100}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleClose}>Close</Button> */}
        <DialogActions>
          <Typography>
            Total Qty{" "}
            {selectedSerials.reduce((sum, item) => sum + item?.Qty, 0)}
          </Typography>
        </DialogActions>
      </DialogActions>
    </Dialog>
  );
};

export default GCSerialSelectionModal;
